module.exports = __webpack_public_path__ + "static/media/37550006-OFT0wSgs.5c376c07.JPG";